export const Roles = [
  { id: "SUPER_ADMIN", name: "ویژه", visible: true },
  { id: "HR_ADMIN", name: "مدیر منابع انسانی", visible: true },
  { id: "HR_PANEL_ADMIN", name: "مدیر پنل منابع انسانی", visible: true },
  { id: "َUSER_EXPERIMENTAL", name: "کاربر آزمایشی", visible: true },
  { id: "USERS_ADMIN", name: " مدیر ", visible: true },
  { id: "UNIT_ADMIN", name: "مدیر واحد", visible: true },
  { id: "MARKETING_ADMIN", name: "کاربر پایه", visible: true },
  { id: "ANBAAR_ADMIN", name: "انباردار", visible: true },
  { id: "SALE_ADMIN", name: "ادمین پنل ", visible: true },
  { id: "LEADER_UNIT_ADMIN", name: "نماینده واحد", visible: true },
  { id: "USER_CRM_SIMPLE", name: "کاربر ساده crm", visible: true },
  { id: "UNIT_CRM_USER", name: "کاربر ارشد crm", visible: true },
  { id: "MANAGER_CRM", name: "مدیر crm", visible: true },
  { id: "SALE_CRM_ADMIN", name: "مدیر فروش crm", visible: true },

  { id: "ROOT", name: "Tech-Dev", visible: false }
];
export const ReminderEnum = [
  // { id: 'NEVER', name: 'هرگز  ' },
  { id: 'AFTER_1_HOUR', name: ' ۱ ساعت' },
  { id: 'AFTER_2_HOUR', name: ' ۲ ساعت' },
  { id: 'AFTER_6_HOUR', name: ' ۶ ساعت' },
  { id: 'AFTER_12_HOUR', name: ' ۱۲ ساعت' },
  { id: 'AFTER_1_DAY', name: ' ۲۴ ساعت' },
  { id: 'AFTER_2_DAY', name: ' ۴۸ ساعت  ' },
  { id: 'AFTER_1_WEEK', name: ' ۱ هفته ' },
  { id: 'AFTER_2_WEEK', name: ' ۲ هفته ' },

]

export const TypeOfCu = [
  { id: "HAGHIGHI", name: "حقیقی", visible: true },
  { id: "HOGHUGHI", name: "حقوقی", visible: true },

];
export const typesOfNotif=[
  { id: "need", name: "درخواست" },
  { id: "loadingRequest", name: "سفارش بار" },
  { id: "customer", name: "مشرتی" },
  { id: "reminder", name: "یادآوری" },
  { id: "groupsms", name: "ارسال گروهی " },
  { id: "contanct", name: "مخاطب" }];
export const CONATACTPRIORITY = [
  { id: "تلفن", name: "تلفن", color: "#f4f450" },
  { id: "واتس‌اپ", name: "واتس‌اپ", color: "#acef92" },
  // "اس ام اس", "تلگرام"
  { id: "تلگرام", name: "تلگرام" },
  { id: "اس ام اس", name: "اس ام اس", }


]

export const Resources = [

]
// export const Units = [
//   {id: "CENTERAL", name: "شعبه مرکزی"},
//   {id: "PRODUCTION", name: "واحد تولید"},
//   {id: "supply", name: "انبار"},
//   {id: "CLEVEL", name: "مدیریت"},
// ];
export const Units = [
  { id: "CENTERAL", name: "شعب" },
  { id: "PRODUCTION", name: "واحد تولید" },
  { id: "SUPPLY", name: "انبار" },
  { id: "CLEVEL", name: "مدیریت" }];
export const SubUnits = {
  CENTERAL: [{ id: "ISF_CENTER", name: 'اصفهان - مرکزی' }, { id: "TEH_!", name: 'تهران - مطهری' }, { id: "ISF_1", name: 'اصفهان - ۵ محرم' }],
  PRODUCTION: [{ id: "PROD_CENTER", name: "خط تولید" }],
  SUPPLY: [{ id: "SUPPLY_CENTER", name: "انبار مرکزی " }],
  CLEVEL: [{ id: "CLEVEL_CEO", name: "سید علی سید مظفری " }, { id: "CLEVEL_CPO", name: " یاد صدف " }],



};
